define('app/controller',['require','../common/baseController','./models/Report','./models/Monitor','./models/DomainCollection','./models/DashboardCollection','./models/UserCollection','./models/SegmentCollection','./editor/ReportPage','./editor/SegmentPage','./editor/MonitorPage','./editor/MetricPage','./editor/AlertPage','glu/util','glu/http','./filters/FiltersView','./filters/SegmentFiltersView','./editor/ReportDefinitionView','./editor/MonitorMetricsView','./editor/MonitorSegmentsView','./dashboard/Dashboard','app/store','app/models/CompoundFilter','glu/collection','app/app','glu/dialog','app/config/reportTypes','glu/$'],function(require) {
	'use strict';

	var BaseController = require('../common/baseController'),
		Report = require('./models/Report'),
		Monitor = require('./models/Monitor'),
		DomainCollection = require('./models/DomainCollection'),
		DashboardCollection = require('./models/DashboardCollection'),
		UserCollection = require('./models/UserCollection'),
		SegmentCollection = require('./models/SegmentCollection'),
		ReportPage = require('./editor/ReportPage'),
		SegmentPage = require('./editor/SegmentPage'),
		MonitorPage = require('./editor/MonitorPage'),
		MetricPage = require('./editor/MetricPage'),
		AlertPage = require('./editor/AlertPage'),
		_ = require('glu/util'),
		http = require('glu/http'),
		FiltersView = require('./filters/FiltersView'),
		SegmentFiltersView = require('./filters/SegmentFiltersView'),
		ReportDefinitionView = require('./editor/ReportDefinitionView'),
		MonitorMetricsView = require('./editor/MonitorMetricsView'),
		MonitorSegmentsView = require('./editor/MonitorSegmentsView'),
		Dashboard = require('./dashboard/Dashboard'),
		sessionStore = require('app/store'),
		CompoundFilter = require('app/models/CompoundFilter'),
		Collection = require('glu/collection'),
		App = require('app/app'),
		Dialog = require('glu/dialog'),
		reportTypes = require('app/config/reportTypes'),
		$ = require('glu/$');

	var token = sessionStore.getApiToken();
	if (token) {
		http.setRequestHeaders({
			'API-TOKEN': token
		});
	}

	// set this value to false to require the user to select click a refresh button after every report change.
	var autoRefresh = true;

	// IE is notorious for its aggressive caching of Ajax responses, we need set a global option: no cache for ajax requests
	$.ajaxSetup({
		cache: false
	});



	return BaseController.extend({

		initialize: function() {
			if (token) {
				// download both the dashboard collection and the domain collection.  We are going to
				// need access to the domains to determine the proper way to filter widgets.
				this.domains = new DomainCollection();
				this.dashboards = new DashboardCollection();
				this.users = new UserCollection();
				this.segments = new SegmentCollection();

				this.openReports = App.openReports;

				App.domains = this.domains;
				App.dashboards = this.dashboards;
				App.users = this.users;
				App.segments = this.segments;

				// Users are not immediately needed, so let the async call finish in the background.
				this.users.fetch();
				this.segments.fetch();
			}
		},

		logout: function() {
			this.sendEvent(App.user.getTenantId(), 'logout', App.user.getUsername());
			if (App.user) {
				App.user.logout();
				App.user = null;
			}
			this.appBus.trigger('http:401');
		},

		dashboard: function(dashboardId) {
			var self = this;

			self.domains.fetch().then(function() {
				self.dashboards.fetch().then(function() {
					var page = new Dashboard({
						collection: self.dashboards,
						dashboardId: dashboardId
					});

					self.showPage('Dashboard', page);
					self.appBus.trigger('nav:dashboard');
				});
			});
			this.sendEvent(App.user.getTenantId(), 'dashboard', dashboardId);

		},

		segment: function(domainId, segmentId) {
			var self = this;

			this.dashboards.fetch().then(function() {
				self.domains.fetch().then(function() {
					var domain = self.domains.get(domainId);
					var segment = self.segments.get(segmentId);
					var openSegment = self.openReports.get(segmentId);

					if (openSegment) {
						self.showSegmentPage(segment, openSegment);
					} else if (domain) {
						domain.fetch().then(function() {
							$.when(domain.reportCollection().fetch({
								domain: domain
							}), self.segments.fetch()).then(function() {
								segment = self.segments.get(segmentId);
								var report = domain.spdReport().clone();
								report.setId(segment.getId());
								report.setName(segment.getName());
								report.setDescription(segment.getDescription());
								report.setReportType(reportTypes.SEGMENT);
								report.loadFilters(segment.get('filters'));
								report.setOwner(sessionStore.getApiUsername());
								report.clean();
								self.showSegmentPage(segment, report);
							});
						});
					}
				});
			});

			this.sendEvent(App.user.getTenantId(), 'segment', segmentId);
		},

		reportFiltered: function(domainId, reportId) {
			this.report(domainId, reportId, true);
		},

		report: function(domainId, reportId, isFiltered) {

			var self = this;

			self.domains.fetch().then(function() {
				self.dashboards.fetch().then(function() {
					var domain = self.domains.get(domainId);
					var report = self.openReports.get(reportId);
					var reportClone;

					if (report) {
						self.showReportPage(report, false, isFiltered);
					} else if (domain) {
						domain.fetch().then(function() {
							return domain.reportCollection().fetch({
								domain: domain
							});
						}).then(function() {
							report = domain.reportCollection().get(reportId);
							if (report) {
								reportClone = report.clone();
								self.showReportPage(reportClone, true, isFiltered);
							} else {
								self.dashboard();
								Dialog.error('Sorry, we could not find this report. It is possible that report was deleted, or is inaccessible due to other reasons.', 'Report not found');
							}
						});
					} else {
						self.dashboard();
						Dialog.error('Sorry, we could not find this report. It is possible that report was deleted, or is inaccessible due to other reasons.', 'Report not found');
					}
				});
			});
			this.sendEvent(App.user.getTenantId(), 'report', reportId);
		},

		unsavedReport: function(domainId, cid) {
			var self = this,
				isFiltered = false;

			var report = self.openReports.get(cid);
			if (report) {
				// Dirty check to see if the origin is a dashboard. If it is, we want to apply the master filter
				if (report.getUrlOrigin() && report.getUrlOrigin().split('/').reverse()[0] === 'dashboard') {
					isFiltered = true;
				}
				self.showReportPage(report, true, isFiltered);
			} else {
				self.dashboard();
				Dialog.error('Sorry, we could not find this report. It is possible that report was deleted, or is inaccessible due to other reasons.', 'Report not found');
			}
		},

		unsavedMonitor: function(domainId, cid) {
			var self = this;

			var monitor = self.openReports.get(cid);
			if (monitor) {
				self.showMonitorPage(monitor, true);
			} else {
				self.dashboard();
				Dialog.error('Sorry, we could not find this monitor. It is possible that monitor was deleted, or is inaccessible due to other reasons.', 'Monitor not found');
			}
		},

		newReport: function(domainId, dashboardId, type) {

			var self = this;

			this.dashboards.fetch().then(function() {
				self.domains.fetch().then(function() {
					var domain = self.domains.get(domainId);
					if (domain) {
						domain.fetch().then(function() {
							var report = new Report({
								name: 'Untitled Report',
								domainId: domainId,
								dashboardId: dashboardId,
								domain: domain,
								type: type,
								reportType: reportTypes.REPORT,
								owner: App.user.getUsername(),
								filter: new CompoundFilter({
									operator: 'AND',
									filterCollection: new Collection()
								})
							});
							return report;
						}).then(_.bind(self.showReportPage, self));
					}
				});
			});
			this.sendEvent(App.user.getTenantId(), 'new report');
		},

		newMonitor: function(domainId, dashboardId) {
			var self = this;

			this.dashboards.fetch().then(function() {
				self.domains.fetch().then(function() {
					var domain = self.domains.get(domainId);
					if (domain) {
						domain.fetch().then(function() {
							var monitor = new Monitor({
								name: 'Untitled Monitor',
								domainId: domainId,
								dashboardId: dashboardId,
								domain: domain,
								owner: App.user.getUsername()
							});
							return monitor;
						}).then(_.bind(self.showMonitorPage, self));
					}
				});
			});
			this.sendEvent(App.user.getTenantId(), 'new monitor');
		},

		monitor: function(domainId, monitorId) {

			var self = this;

			$.when(self.domains.fetch(), self.dashboards.fetch()).then(function() {
				var domain = self.domains.get(domainId);
				var monitor = self.openReports.get(monitorId);
				if (monitor) {
					self.showMonitorPage(monitor, false);
				} else if (domain) {
					domain.fetch().then(function() {
						return domain.monitorCollection().fetch({
							domain: domain
						});
					}).then(function() {
						monitor = domain.monitorCollection().get(monitorId);
						if (monitor) {
							monitor.setDomain(domain);
							self.showMonitorPage(monitor.clone(), true);
						} else {
							self.dashboard();
							Dialog.error('Sorry, we could not find this monitor. It is possible that monitor was deleted, or is inaccessible due to other reasons.', 'Monitor not found');
						}
					});
				} else {
					self.dashboard();
					Dialog.error('Sorry, we could not find this monitor. It is possible that monitor was deleted, or is inaccessible due to other reasons.', 'Monitor not found');
				}
			});
			this.sendEvent(App.user.getTenantId(), 'monitor', monitorId);
		},

		showReportPage: function(report, isLoadingFirstTime, isFiltered) {
			if (isFiltered) {
				report.applyMasterFilter();
			}

			this.openReports.add(report);

			this.appBus.trigger('nav:report', report);

			var reportPage;
			if (report.getReportType() === reportTypes.METRIC) {
				reportPage = new MetricPage({
					autoRefresh: autoRefresh,
					model: report
				});
			} else if (report.getReportType() === reportTypes.ALERT) {
				reportPage = new AlertPage({
					autoRefresh: autoRefresh,
					model: report
				});
			} else {
				reportPage = new ReportPage({
					autoRefresh: autoRefresh,
					model: report
				});
			}

			reportPage.reportDefinitionView = new ReportDefinitionView({
				autoRefresh: autoRefresh,
				model: report
			});

			reportPage.filtersView = new FiltersView({
				autoRefresh: autoRefresh,
				model: report
			});

			this.showPage('Report', reportPage);

			if (report.isRunnable() && (isLoadingFirstTime || report.isDirty())) {
				report.run();
			}

		},

		showSegmentPage: function(segment, report) {

			this.openReports.add(report);

			this.appBus.trigger('nav:report', report);


			var segmentPage = new SegmentPage({
				autoRefresh: autoRefresh,
				model: report,
				segment: segment
			});

			segmentPage.filtersView = new SegmentFiltersView({
				autoRefresh: autoRefresh,
				model: report
			});

			this.showPage('Segment', segmentPage);

			if (report.isRunnable() && report.isDirty()) {
				report.run();
			}
		},

		showMonitorPage: function(monitor, isLoadingFirstTime) {

			this.openReports.add(monitor);

			this.appBus.trigger('nav:monitor', monitor);

			var monitorPage = new MonitorPage({
				autoRefresh: autoRefresh,
				model: monitor
			});

			monitorPage.metricsView = new MonitorMetricsView({
				autoRefresh: autoRefresh,
				model: monitor
			});

			monitorPage.segmentsView = new MonitorSegmentsView({
				autoRefresh: autoRefresh,
				model: monitor
			});

			this.showPage('Monitor', monitorPage);

			if (monitor.isRunnable() && (isLoadingFirstTime || monitor.isDirty())) {
				monitor.run();
			}
		},

		sendEvent: function(eventCategory, eventAction, eventLabel, eventValue) {
			try {
				if (ga) {
					ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
				}
			} catch (err) {
				// do not log the error
			}
		}
	});
});

